import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import ScrollToTop from '@/components/ScrollToTop';
import QuickNavigator from '@/components/QuickNavigator';
import Footer from '@/components/Footer';

export default function RootLayout() {
    const location = useLocation();
    const isAdminPage = location.pathname.startsWith('/admin');
    const isBharatConnectSubPage = /^\/product\/bharat-connect-.+/.test(location.pathname);
    const isNoShellPage = location.pathname === '/login' || isAdminPage || isBharatConnectSubPage;

    // Admin has its own full-screen shell — skip global nav & footer entirely
    if (isAdminPage) {
        return (
            <>
                <ScrollToTop />
                <Outlet />
            </>
        );
    }

    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <ScrollToTop />
            <Navbar />
            {!isNoShellPage && <QuickNavigator />}
            <main className="flex-grow flex flex-col relative">
                <Outlet />
            </main>
            {!isNoShellPage && <Footer />}
        </div>
    );
}
